import styled from 'styled-components';

export const Content = styled.main`
  padding: 8px 30px 70px;
  @media (max-width: 767px) {
    padding-left: 16px;
    padding-right: 16px;
  }
  min-height: calc(100vh - 120px);

  video {
    border-radius: 10px;
    box-shadow: 0 8px 10px rgba(0, 0, 0, 0.05);
    max-width: 850px;
  }
`;
